import React from "react";
import "react-quill/dist/quill.snow.css";
import "tailwindcss/tailwind.css";

const Icon = ({ field, style }) => {
  const styles = {
    width: "80px",
    height: "80px",
    background: style?.background || "blue",
    borderRadius: "50%",
    margin: "0 auto",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignIterms: "center",
    boxShadow: style?.boxShadow || "",
  };

  return (
    <div style={styles}>
      <i
        className={field.value}
        style={{ fontSize: "26px", color: "#fff" }}
      ></i>
    </div>
  );
};

export default Icon;
